import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";

import { publicRoutes } from "./allRoutes";

const Index = (props: any) => {
  return (
    <Routes>
      {publicRoutes.map((route: any, idx: number) => (
        <Route
          path={route.path}
          element={route.component}
          key={idx}
        />
      ))}
      <Route path="/googleab7e92e76f134487.html" element={null} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default Index;